import { render, staticRenderFns } from "./rejectTip.vue?vue&type=template&id=24ded8dc&scoped=true"
import script from "./rejectTip.vue?vue&type=script&lang=ts"
export * from "./rejectTip.vue?vue&type=script&lang=ts"
import style0 from "./rejectTip.vue?vue&type=style&index=0&id=24ded8dc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24ded8dc",
  null
  
)

export default component.exports